import { Pipe, PipeTransform } from '@angular/core'
import { getBirthTime } from '../services/saju/saju.utils'
/**
 * birthtime formatting pipe
 */
@Pipe({
  name: 'birthTime',
})
export class SajuBirthTimePipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) {
      return ''
    }

    return getBirthTime(value)
  }
}
